import { gql } from '@apollo/client';

export const packageFragments = {
  packageItem: gql`
    fragment PackageItem on Package {
      id
      updatedTime
      updatedBy
      updatedByUser {
        id
        nameFirst
        nameLast
      }
      description
      unit
      tag
      type
      status
      plannedEndDate
      plannedStartDate
      actualEndDate
      actualStartDate
      misc1
      misc2
      misc3
      misc4
      misc5
      misc6
      foreman
      generalForeman
      ownerId
      responsibleFieldEng
      responsibleSuperintendent
      packageView {
        id
        hasCables
        hasEquipment
        hasJumpers
        hasRaceways
        hasTerms
      }
    }
  `,
};

export const SEARCH_PACKAGES = gql`
  ${packageFragments.packageItem}
  query SearchPackages($searchInput: SearchInput) {
    searchPackages(searchInput: $searchInput) {
      items {
        ...PackageItem
      }
    }
  }
`;

export const GET_PACKAGE_BY_ID = gql`
  ${packageFragments.packageItem}
  query PackageById($id: ID!) {
    packageById(id: $id) {
      ...PackageItem
    }
  }
`;

export const GET_PACKAGE_VIEW_STATS = gql`
  query GetPackageViewStats($id: ID!) {
    packageById(id: $id) {
      id
      packageView {
        id
        hasCables
        hasEquipment
        hasJumpers
        hasRaceways
        hasTerms
      }
    }
  }
`;

export const UPDATE_PACKAGE = gql`
  ${packageFragments.packageItem}
  mutation UpdatePackage($updatePackageInput: UpdatePackageInput!) {
    updatePackage(updatePackageInput: $updatePackageInput) {
      package {
        ...PackageItem
      }
      errors
    }
  }
`;

export const CREATE_PACKAGE = gql`
  ${packageFragments.packageItem}
  mutation CreatePackage($createPackageInput: CreatePackageInput!) {
    createPackage(createPackageInput: $createPackageInput) {
      package {
        ...PackageItem
      }
      errors
    }
  }
`;

export const DELETE_PACKAGE = gql`
  mutation DeletePackage($deletePackageInput: DeletePackageInput!) {
    deletePackage(deletePackageInput: $deletePackageInput) {
      errors
      id
    }
  }
`;

export const UPDATE_PACKAGES = gql`
  ${packageFragments.packageItem}
  mutation UpdatePackages($updatePackagesInput: [UpdatePackageInput!]!) {
    updatePackages(updatePackagesInput: $updatePackagesInput) {
      packages {
        ...PackageItem
      }
      infos {
        tag
        messageKeys
      }
      errors {
        tag
        messageKeys
      }
    }
  }
`;

export const GET_ASSOCIATED_PACKAGES_BY_ID = gql`
  query AssociatedCommodityByPackageId($associatedCommodityByPackageIdId: ID!) {
    associatedPackagesByPackageId(id: $associatedCommodityByPackageIdId) {
      package {
        id
        tag
      }
      description
      tag: commodityTag
      commodity {
        ... on Cable {
          id
          tag
        }
        ... on Raceway {
          id
          tag
        }
        ... on Equipment {
          id
          tag
        }
        ... on Jumper {
          id
          tag
        }
      }
      commType
      assignedDate
      asBuiltDate
    }
  }
`;
